import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash.clonedeep';

import FilterNothingSelectable from './filter-nothing-selectable';
import Filter from './filter';

const optionsForLevel = (level, products) => {
  return level.options.filter((option) =>
    products.some((product) => product.filters[level.title] === option.title),
  );
};

const filteredProducts = (
  level,
  products,
  selectedProp,
  selectedDeliveryOptions = null,
) => {
  const selected = cloneDeep(selectedProp);
  delete selected[level.title];

  if (selectedDeliveryOptions !== null) {
    products = products.filter((product) =>
      product.delivery_options.includes(parseInt(selectedDeliveryOptions)),
    );
  }

  if (Object.keys(selected).length) {
    return Object.keys(selected).reduce(
      (acc, filter) =>
        acc.filter((product) => product.filters[filter] === selected[filter]),
      products,
    );
  }

  return products;
};

export default function Filters(props) {
  const { products, selected, levels, deliveryOptions, onCriteronSelected } = props;
  const $filters = [];

  levels.forEach((level) => {
    let $filter;

    // do the products include this option?
    if (
      products.some(
        (product) =>
          product.filters[level.title] &&
          level.options
            .map((option) => option.title)
            .indexOf(product.filters[level.title]) > -1,
      )
    ) {
      const options = optionsForLevel(level, products);

      if (options.length === 1) {
        $filter = (
          <FilterNothingSelectable
            key={level.title}
            level={level}
            option={options[0]}
          />
        );
      } else {
        $filter = (
          <Filter
            key={level.title}
            level={level}
            selected={selected[level.title]}
            products={products}
            currentProducts={filteredProducts(level, products, selected, props.selectedDeliveryOptions)}
            deliveryOptions={deliveryOptions}
            onCriteronSelected={onCriteronSelected}
          />
        );
      }
    }

    if ($filter) {
      $filters.push($filter);
    }
  });

  if ($filters.length === 0) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: products[0].absence_of_options_message,
        }}
      />
    );
  }

  return <div>{$filters}</div>;
}

Filters.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  selected: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  levels: PropTypes.arrayOf(PropTypes.object),
  deliveryOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCriteronSelected: PropTypes.func.isRequired,
  selectedDeliveryOptions: PropTypes.string,
};

Filters.defaultProps = {
  selected: {},
  levels: [],
}
